import { render, staticRenderFns, recyclableRender, components } from "./LazyLoad.vue?vue&type=template&id=1dc4b581&scoped=true&"
var renderjs
import script from "./LazyLoad.vue?vue&type=script&lang=js&"
export * from "./LazyLoad.vue?vue&type=script&lang=js&"
import style0 from "./LazyLoad.vue?vue&type=style&index=0&id=1dc4b581&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc4b581",
  null,
  false,
  components,
  renderjs
)

export default component.exports